import { render, staticRenderFns } from "./ConfigurationEmailOptionsDoc.vue?vue&type=template&id=b6e518ec"
import script from "./ConfigurationEmailOptionsDoc.vue?vue&type=script&lang=js"
export * from "./ConfigurationEmailOptionsDoc.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationEmailOptionsDoc.vue?vue&type=style&index=0&id=b6e518ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports